import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {
  registerStaleLazyChunkRecovery,
  removeCacheBustParam,
} from './app/shared/helpers/lazy-chunk-reload.helper';

removeCacheBustParam();
registerStaleLazyChunkRecovery();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
